import { forwardRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function CustomInputDate({ onDateChange, disabled }) {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const CustomInput = forwardRef(({ onClick }, ref) => (
    <button className="btn" onClick={onClick} ref={ref} disabled={disabled}>
      Tùy chỉnh
    </button>
  ));

  const handleOnChange = (date) => {
    setDateRange(date);
    onDateChange(date);
  };

  return (
    <DatePicker
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => {
        handleOnChange(update);
      }}
      customInput={<CustomInput />}
      withPortal
    />
  )
}

export default CustomInputDate;
